<div class="new-mobile-menu-container">
  <app-icon [icon]="Icons.logoBorder" (click)="openUrl('/')"/>
  <div class="mobile-menu-sections">
    <div class="mobile-menu-section" style="margin-top: 28px">
      <div *ngFor="let element of elements">
        <div class="mobile-menu-section-el" (click)="onClick(element)">
          <app-texts [texts]="[{text: [element.titleRu, element.titleEn]}]"/>
        </div>
      </div>
    </div>
    <div class="mobile-menu-section" style="gap: 5px">
      <div class="mobile-menu-section-el-mini" (click)="openUrl('/')">
        <app-texts [texts]="[{text: ['Главная', 'Main']}]"/>
      </div>
      <div class="mobile-menu-section-el-mini" (click)="openUrl('/feedback')">
        <app-texts [texts]="[{text: ['Контакты', 'Get in Touch']}]"/>
      </div>
      <div class="mobile-menu-section-el-mini" (click)="localizationService.setLanguage()">
        <app-texts [texts]="[{text: ['Rus | Eng', 'Rus | Eng']}]"/>
      </div>
    </div>
  </div>
</div>
